import config from "../config";
import { requests } from ".";

export const SmsComplianceService = {

  getMessageUsageStats: async (locationId: string) => {
    const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).get(
      `/rate-limiter/location/${locationId}/sms/usage`
    )
    return data;
  },
};
